import React from 'react';
import Header            from '../components/landing/Header';
import HeroSection       from '../components/landing/HeroSection';
import DemoSection       from '../components/landing/DemoSection';
import BeamSection       from '../components/landing/BeamSection';
import HowItWorksSection from '../components/landing/HowItWorksSection';
import FeaturesSection   from '../components/landing/FeaturesSection';
import AudienceSection   from '../components/landing/AudienceSection';
import RoadmapSection    from '../components/landing/RoadmapSection';
import CTASection        from '../components/landing/CTASection';
import Footer            from '../components/landing/Footer';
import ProblemSection from "../components/landing/ProblemSection";

const HomePage = () => (
  <div className="min-h-screen bg-gray-950 text-white">
    <Header />
    <main>
      <HeroSection />
      <DemoSection />
      <BeamSection />
      <ProblemSection />
      <HowItWorksSection />
      <FeaturesSection />
      <AudienceSection />
      <RoadmapSection />
      <CTASection />
    </main>
    <Footer />
  </div>
);

export default HomePage;
